import { IconHelpChat } from '@picsart/design-system/foundation/icons/IconHelpChat';
import { IconFile } from '@picsart/design-system/foundation/icons/IconFile';
import { IconShieldVerified } from '@picsart/design-system/foundation/icons/IconShieldVerified';

import type { SettingsLink } from './types';

export const formatVersionCode = (raw: string | undefined): string => {
  if (!raw) return '';
  const trimmed = raw.slice(4);
  const major = trimmed.slice(0, 2);
  const minor = trimmed.slice(2, 3);
  const patch = trimmed.slice(3);
  if (!patch || /^0+$/.test(patch)) return `${major}.${minor}`;
  const patchFormatted = patch.length === 1 ? `0${patch}` : patch;
  return `${major}.${minor}.${patchFormatted}`;
};

export const HELP_LINKS: SettingsLink[] = [
  {
    label: 'Help Center',
    url: 'https://support.picsart.com/hc/en-us',
    icon: IconHelpChat,
  },
];

export const ABOUT_LINKS: SettingsLink[] = [
  {
    label: 'Terms of Use',
    url: 'https://picsart.com/terms-of-use',
    icon: IconFile,
  },
  {
    label: 'License Contribution',
    url: 'https://picsart.com/license/ios/?app=1',
    icon: IconFile,
  },
  {
    label: 'Privacy Policy',
    url: 'https://picsart.com/privacy-policy',
    icon: IconShieldVerified,
  },
  {
    label: 'Do Not Sell My Info',
    url: 'https://privacy.picsart.com/optout?app=1',
    icon: IconShieldVerified,
  },
  {
    label: 'DMCA',
    url: 'https://picsart.com/copyright-dispute-policy',
    icon: IconFile,
  },
];
